module.exports = __webpack_public_path__ + "static/img/jzz.d0ba900.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jzz.gif
// module id = xJ9+
// module chunks = 1